import React from "react";
import { NavLink as RouterNavLink } from "react-router-dom";
import { useAuth0 } from "../../auth/react-auth0-wrapper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledTooltip
} from "reactstrap";

const UserNav = ({ path }) => {
    const { user, logout } = useAuth0();
    const logoutWithRedirect = () =>
        logout({
            returnTo: window.location.origin
        });
    return (
        <UncontrolledDropdown className="ml-1 mt-1">
            <DropdownToggle color="secondary" id="userNavbarButton" caret>
                <FontAwesomeIcon icon="power-off" /><span className="d-none d-xl-block">Logout</span>
            </DropdownToggle>
            <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="userNavbarButton">
                Logout
            </UncontrolledTooltip>
            <DropdownMenu>
                <DropdownItem header><FontAwesomeIcon icon="user" /> {user.name}</DropdownItem>
                <DropdownItem
                    id="qsLogoutBtn"
                    onClick={() => logoutWithRedirect()}
                >
                    <FontAwesomeIcon icon="power-off" className="mr-3" /> Logout
                    </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown >
    );
};

export default UserNav;
